import { render } from "./EditProduct.vue?vue&type=template&id=9bea7104&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=9bea7104&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=9bea7104&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bea7104"]])

export default __exports__